import type { Variants, Transition } from 'framer-motion';

const spring: Transition = {
  type: 'spring',
  stiffness: 360,
  damping: 30,
  mass: 0.8,
};

const gentleSpring: Transition = {
  type: 'spring',
  stiffness: 260,
  damping: 28,
  mass: 0.9,
};

export const liquidPanel: Variants = {
  hidden: { opacity: 0, scale: 0.96, y: 14, filter: 'blur(8px)' },
  visible: { opacity: 1, scale: 1, y: 0, filter: 'blur(0px)', transition: gentleSpring },
  exit: { opacity: 0, scale: 0.97, y: 10, filter: 'blur(6px)', transition: { duration: 0.16 } },
};

export const liquidWindow: Variants = {
  hidden: { opacity: 0, scale: 0.94, y: 18, filter: 'blur(10px)' },
  visible: { opacity: 1, scale: 1, y: 0, filter: 'blur(0px)', transition: spring },
  minimized: { opacity: 0, scale: 0.82, y: 120, filter: 'blur(12px)', transition: { duration: 0.18 } },
};

export const liquidIcon = {
  hover: { scale: 1.06, y: -3, transition: spring },
  tap: { scale: 0.94, y: 1, transition: { duration: 0.1 } },
};

export const liquidButton = {
  hover: { scale: 1.035, y: -1, transition: spring },
  tap: { scale: 0.965, y: 0, transition: { duration: 0.1 } },
};

export function getLiquidTransition(reducedMotion: boolean): Transition {
  if (reducedMotion) {
    return { duration: 0.12 };
  }

  return spring;
}

export function getLiquidInteraction(reducedMotion: boolean) {
  if (reducedMotion) {
    return {
      whileHover: undefined,
      whileTap: undefined,
    };
  }

  return {
    whileHover: liquidButton.hover,
    whileTap: liquidButton.tap,
  };
}
